import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAuth } from "@/contexts/AuthContext"
import { Loader2 } from "lucide-react"
import { useEffect } from "react"

export default function ProtectedRoute() {
  const { isAuthenticated, isAdmin, isLoading, logout } = useAuth()
  const location = useLocation()

  // Clear session if user is not admin
  useEffect(() => {
    if (!isLoading && isAuthenticated && !isAdmin) {
      logout()
    }
  }, [isLoading, isAuthenticated, isAdmin, logout])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated || !isAdmin) {
    // Redirect to login if not authenticated or not admin
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
